export default __webpack_public_path__ + "static/media/questionMark.0830476d.svg";